import React, { useEffect, useState } from 'react';

import {
  DocumentFields,
  DocumentsSections,
} from '@cd3p/core/modules/documents';
import { APILanguage } from '@cd3p/core/types/api';
import i18n from 'i18n';

import { useParams, useSelector, useTranslation } from 'third-party';

import { helpCenterEditorUrl } from 'constants/url';

import { useHelpCenter } from 'modules/helpCenter';

import { helpCenterSelectors } from 'selectors';

import { DocsEditor } from 'features/Docs/DocsEditor';

const applicationsOptions = [
  {
    label: i18n.t('docs.applications.contractorWeb'),
    value: DocumentsSections.HelpCenterWebContractor,
  },
  {
    label: i18n.t('docs.applications.providerWeb'),
    value: DocumentsSections.HelpCenterWebDispatcher,
  },
  {
    label: i18n.t('docs.applications.contractorMobile'),
    value: DocumentsSections.HelpCenterMobileContractor,
  },
];

const editHiddenFields = [DocumentFields.PublishedDate];

export const HelpCenterEditor = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState<APILanguage>(APILanguage.English);

  const { applicationId, documentId } = useParams();

  const {
    loadHelpCenterDocuments,
    saveHelpCenterDocument,
    deleteHelpCenterDocument,
    fetchHelpCenterDocument,
    resetHelpCenterDocuments,
  } = useHelpCenter(applicationId as DocumentsSections, language);

  const items = useSelector(helpCenterSelectors.helpCenterItemsTree);
  const itemsLoading = useSelector(helpCenterSelectors.helpCenterItemsLoading);
  const itemsLoaded = useSelector(helpCenterSelectors.helpCenterItemsLoaded);
  const documentLoading = useSelector(
    helpCenterSelectors.fetchHelpCenterDocumentPending,
  );

  useEffect(() => {
    return () => {
      resetHelpCenterDocuments();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DocsEditor
      title={t('helpCenter.title')}
      applicationId={applicationId as DocumentsSections}
      documentId={documentId}
      items={items}
      itemsLoading={itemsLoading}
      itemsLoaded={itemsLoaded}
      documentLoading={documentLoading}
      loadDocuments={loadHelpCenterDocuments}
      saveDocument={saveHelpCenterDocument}
      deleteDocument={deleteHelpCenterDocument}
      fetchDocument={fetchHelpCenterDocument}
      editorUrl={helpCenterEditorUrl}
      language={language}
      setLanguage={setLanguage}
      applications={applicationsOptions}
      editHiddenFields={editHiddenFields}
    />
  );
};
